import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Section Components
import Hero from "./components/sections/Hero";
import HowItWorks from "./components/sections/HowItWorks";
import Comparison from "./components/sections/Comparison";
import BrandAnalysis from "./components/sections/BrandAnalysis";
import Problems from "./components/sections/Problems";
import Features from "./components/sections/Features";
import FAQ from "./components/sections/FAQ";
import FinalCTA from "./components/sections/FinalCTA";
import BrandInputForm from "./components/sections/BrandInputForm";
import ReportDisplay from "./components/sections/ReportDisplay";

// Legal Pages
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import TermsOfService from "./components/pages/TermsOfService";
import Unsubscribe from "./components/pages/Unsubscribe";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <BrandAnalysis />
        <Comparison />
        <Problems />
        <Features />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

const CreateReportPage = () => {
  const navigate = useNavigate();

  const handleReportCreated = (reportId) => {
    navigate(`/report/${reportId}`);
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <a href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">L</span>
            </div>
            <span className="text-xl font-bold text-white">
              Loca<span className="text-emerald-400">Leap</span>
            </span>
          </a>
        </div>
      </div>
      <BrandInputForm onReportCreated={handleReportCreated} />
    </div>
  );
};

const ReportPage = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/create");
  };

  return <ReportDisplay reportId={reportId} onBack={handleBack} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create" element={<CreateReportPage />} />
          <Route path="/report/:reportId" element={<ReportPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
